module.exports = require("classnames");


/*****************
 ** WEBPACK FOOTER
 ** external "classnames"
 ** module id = 5
 ** module chunks = 0
 **/